import { DonationApiClient } from '@fourthwall/services/dist/DonationApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDonationsQuery = createQueryHook(DonationApiClient.getDonations, {
  queryKey: ['donations'],
})
